import { AbstractControl, ValidationErrors } from '@angular/forms';

const nonzeroValidationError = { nonzero: true };

export const nonzeroValidator = (control: AbstractControl): ValidationErrors | null => {
  return control.value == 0 ? nonzeroValidationError : null;
};
